// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Column } from 'react-table'
import { UserActionsCell } from './UserActionsCell'
import { UserSelectionCell } from './UserSelectionCell'
import { UserCustomHeader } from './UserCustomHeader'
import { UserSelectionHeader } from './UserSelectionHeader'
import { UserInfoLogo } from './UserInfoLogo'
import { OrderPickStatus } from './OrderPickStatus'


const usersColumns: ReadonlyArray<Column<Order>> = [
  {
    Header: (props) => <UserSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <UserSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Date' className='min-w-125px' />,
    accessor: 'created_at',
    Cell: ({ ...props }) => {
      return (
        <div className='d-flex flex-column'>
          <span className='text-gray-800 fs-7'>{props.row.original.pickup_date ? props.row.original.pickup_date : props.row.original.order_date}</span>
          <span className='text-gray-600 fs-8'>{props.row.original.pickup_time ?props.row.original.pickup_time : props.row.original.order_time}</span>
        </div>
      )
    },
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Customer' className='min-w-125px' />,
    accessor: 'get_user',
    Cell: ({ ...props }) => {
      if (props.row.original.get_user != null) {
        return (
          <div className='d-flex flex-column'>
            <span className='text-gray-800 fs-7'>{props.row.original.get_user?.name}</span>
            <span className='text-gray-600 fs-8'>{props.row.original.get_user?.primary_contact}</span>
          </div>
        )
      }
      return <span className='badge badge-light-gray fs-8'>--</span>
    },
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Vehicle' className='min-w-125px' />,
    accessor: 'get_brand',
    Cell: ({ ...props }) => {
      if (props.row.original.get_brand != null) {
        return (
          <div className='d-flex flex-column'>
            <span className='text-gray-800 fs-7'>
              {props.row.original.get_brand?.name} - {props.row.original.get_model?.model}
            </span>
            <span className='text-gray-600 fs-8'>{props.row.original.registration_no}</span>
          </div>
        )
      }
      return <span className='badge badge-light-gray fs-8'>--</span>
    },
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Amount' className='min-w-125px' />,
    accessor: 'total_price',
    Cell: ({ ...props }) => {
      if (props.row.original.total_price != null) {
        return (
          <div className='d-flex flex-column'>
            <div className='d-flex gap-2 align-items-center'>
              <span className='text-gray-600 fs-8'>Total:</span>
              <span className='text-gray-800 fs-7 fw-bold'>
                {parseFloat(props.row.original.total_price).toLocaleString('en-IN', {
                  style: 'currency',
                  currency: 'INR'
                })}
              </span>
            </div>
            <div className='d-flex gap-2 align-items-center'>
              <span className='text-gray-600 fs-8'>Paid:</span>
              <span className='text-gray-800 fs-7 fw-bold'>
                {parseFloat(props.row.original.amount_paid).toLocaleString('en-IN', {
                  style: 'currency',
                  currency: 'INR'
                })}
              </span>
            </div>
            {props.row.original.coupon_name && (
              <>
                <div className='d-flex gap-2 align-items-center'>
                  <span className='text-gray-600 fs-8'>Coupon:</span>
                  <span className='badge badge-light-primary fs-8'>{props.row.original.coupon_name}</span>
                </div>
                <div className='d-flex gap-2 align-items-center'>
                  <span className='text-gray-600 fs-8'>Discount:</span>
                  <span className='badge badge-light-success fs-8'>
                    {parseFloat(`${props.row.original.coupon_amount}`).toLocaleString('en-IN', {
                      style: 'currency',
                      currency: 'INR'
                    })}
                  </span>
                </div>
              </>
            )}
          </div>
        )
      }
      return <span className='badge badge-light-gray fs-8'>0.00</span>
    },
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Address' className='min-w-125px' />,
    accessor: 'pick',
    Cell: ({ ...props }) => {
      if (props.row.original.pick != null) {
        return (
          <div className='d-flex flex-column'>
            <span className='text-gray-800 fs-7'>{props.row.original.pick}</span>
          </div>
        )
      }
      return <span className='badge badge-light-gray fs-8'>---</span>
    },
  },
  // {
  //   Header: (props) => <UserCustomHeader tableProps={props} title='Name' className='min-w-125px' />,
  //   id: 'name',
  //   Cell: ({...props}) => <UserInfoCell user={props.data[props.row.index]} />,
  // },
  // {
  //   Header: (props) => <UserCustomHeader tableProps={props} title='Status' className='min-w-125px' />,
  //   accessor: 'status',
  //   Cell: ({...props}) => <StatusCell brand={props.data[props.row.index]} />,
  // },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Garage' className='min-w-125px' />,
    accessor: 'status',
    Cell: ({ ...props }) => <UserInfoLogo brand={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Status' className='min-w-125px' />,
    accessor: 'pickup',
    Cell: ({ ...props }) => (
      <div className='d-flex align-items-center'>
        <OrderPickStatus brand={props.data[props.row.index]} />
      </div>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({ ...props }) => (
      <div className='d-flex justify-content-end'>
        <UserActionsCell id={props.data[props.row.index].id} />
      </div>
    ),
  },
]

export { usersColumns }
